<div id="linq-sockets-progress" class="linqsockets-progress" [class.active]="numProcesses > 0">
	<header class="linqsockets-progress-header">
		<div class="linqsockets-progress-title linqsockets-ellipsis">
			Work in Progress
		</div>

		<div [textContent]="numProcesses" class="linqsockets-badge linqsockets-progress-badge"></div>
	</header>

	<div class="linqsockets-progress-content" #processContainer>
		<div *ngFor="let entry of progress | keyvalue" (click)="clickProcess(entry.value, $event)"
			[attr.data-linqsockets-progress-process]="entry.key" class="linqsockets-progress-process" #process>
			<div [textContent]="entry.value.Message.Title" class="linqsockets-progress-subtitle"></div>
			<div [textContent]="entry.value.Message.Description" class="linqsockets-progress-body"></div>

			<div class="linqsockets-progress-bar">
				<div [ngStyle]="getProgressBarStyle(entry.value)" class="linqsockets-progress-bar-foreground">
					{{ (entry.value?.frac || 0) * 100 | number: '1.0-0' }}%
				</div>
			</div>
		</div>
	</div>
</div>